import { useState } from 'react';

export default function AboutSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            {!imgError ? (
              <div className="w-full max-w-[480px] mx-auto aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20home%20entertainment%20scene%20with%20a%20large%20screen%20displaying%20abstract%20cinematic%20content%2C%20cozy%20living%20room%20atmosphere%20with%20soft%20ambient%20lighting%2C%20popcorn%20and%20snacks%20nearby%2C%20comfortable%20modern%20setting%2C%20warm%20golden%20tones%2C%20lifestyle%20photography%20style%2C%20relaxed%20evening%20mood%2C%20high%20detail&width=960&height=720&seq=about-platform-visual&orientation=landscape"
                  alt="久久影视 - 品牌介绍"
                  className="w-full h-full object-cover object-top rounded-lg"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="w-full max-w-[480px] mx-auto aspect-[4/3] rounded-lg bg-background-200 flex items-center justify-center">
                <i className="ri-movie-line text-5xl text-foreground-300"></i>
              </div>
            )}
          </div>
          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              关于久久影视
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                久久影视成立于对影视热爱的初心——我们是一群重度追剧爱好者，深知等更新、
                找资源的痛苦。于是我们打造了这个平台，专注于<strong>最新电视剧更新</strong>与
                <strong>最新电影上映</strong>的动态追踪。
              </p>
              <p>
                从国产热门到海外口碑佳作，从院线新片到经典回顾，久久影视以
                <strong>影视更新快</strong>为核心优势，让你不再错过任何一部值得追的好内容。
                <strong>新剧抢先看</strong>是我们的承诺，<strong>最新综艺在线</strong>同步更新，
                高清不卡，让每一次追剧都成为享受。
              </p>
              <p>
                我们不生产内容，只做最懂追剧党的导航——帮你筛选、整理、发现，
                让追剧变成一件简单又快乐的事。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}